export const GET_TAG = "GET_TAG";
export const GET_TAG_MASTER = "GET_TAG_MASTER";
export const GET_POS = "GET_POS";
export const GET_POS_REASONS_WITH_MATERIAL = "GET_POS_REASONS_WITH_MATERIAL";
export const GET_POS_EMP_DATA = "GET_POS_EMP_DATA";
export const REQUIRED_DOCUMENTS = "REQUIRED_DOCUMENTS";
export const SAVE_COMPETITON_MAPPING = "SAVE_COMPETITON_MAPPING";
export const COMPETITION_MAPPING_DATA = "COMPETITION_MAPPING_DATA";
export const FETCH_SITE_NAME = "FETCH_SITE_NAME";